"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _decoration = require("@/api/decoration");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'DecorationSchedule',
  data: function data() {
    return {
      loading: false,
      searchForm: {
        page: 1,
        limit: this.$constants.page.limit[0],
        keywords: '',
        projectStatus: 'in_progress',
        overdue: false
      },
      tableData: {
        data: [],
        total: 0
      },
      statusText: {
        pending: '待开始',
        in_progress: '进行中',
        pending_confirm: '待确认',
        paused: '已暂停',
        completed: '已完成',
        cancelled: '已取消'
      },
      typeText: {
        procedure: '施工工序',
        material: '材料节点',
        acceptance: '验收节点',
        payment: '付款节点',
        milestone: '里程碑'
      }
    };
  },
  computed: {
    nodeTotal: function nodeTotal() {
      return this.tableData.data.reduce(function (sum, item) {
        return sum + Number(item.totalCount || 0);
      }, 0);
    },
    completedTotal: function completedTotal() {
      return this.tableData.data.reduce(function (sum, item) {
        return sum + Number(item.completedCount || 0);
      }, 0);
    },
    overdueTotal: function overdueTotal() {
      return this.tableData.data.reduce(function (sum, item) {
        return sum + Number(item.overdueCount || 0);
      }, 0);
    }
  },
  created: function created() {
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _this = this;
      this.loading = true;
      (0, _decoration.decorationScheduleListApi)(this.searchForm).then(function (res) {
        _this.tableData.data = res.list || [];
        _this.tableData.total = res.total || 0;
      }).finally(function () {
        _this.loading = false;
      });
    },
    handleSearch: function handleSearch() {
      this.searchForm.page = 1;
      this.getList();
    },
    handleReset: function handleReset() {
      this.searchForm = {
        page: 1,
        limit: this.searchForm.limit,
        keywords: '',
        projectStatus: 'in_progress',
        overdue: false
      };
      this.getList();
    },
    handleSizeChange: function handleSizeChange(value) {
      this.searchForm.limit = value;
      this.searchForm.page = 1;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(value) {
      this.searchForm.page = value;
      this.getList();
    },
    date: function date(value) {
      return value ? String(value).slice(0, 10) : '--';
    },
    currentNode: function currentNode(row) {
      var node = (row.schedules || []).find(function (item) {
        return ['in_progress', 'pending_confirm', 'paused'].includes(item.status);
      }) || (row.schedules || []).find(function (item) {
        return item.status === 'pending';
      });
      return node ? node.nodeName : '全部完成';
    }
  }
};